import featureFlagEnums from '@enums/feature-flags';
import routeNames from '@enums/route-names';
import store from '@/js/store';
import SupplierPage from './supplier.vue';
import guardsMap from './supplier-guards-map';

const EmptyRouteComponent = {
    render: () => null,
};

const defaultBeforeEnter = (to, from) => {
    guardsMap[to.name](to, from);
};
const routes = [
    {
        path: '/supplier',
        id: 'supplier',
        featureToggle: 'canAccessSupplierPage',
        component: SupplierPage,
        linkText: 'navBar.supplier',
        index: 2,
        meta: {
            canAccess: featureFlagEnums.canAccessSupplierPage,
            isSideBarExpanded: false,
            tabTitle: 'navBar.supplier',
        },
        async beforeEnter() {
            await store.dispatch('supplierCommitments/resetSupplierCommitmentsState');
            await Promise.all([
                store.dispatch('hierarchy/fetchHierarchy'),
                store.dispatch('storeGroups/fetchStoreGroups'),
            ]);
            return true;
        },
        children: [
            // Default route to ensure that all '/supplier' requests are redirected to the '/supplier/commitments'.
            {
                path: '',
                name: 'supplier',
                redirect: { name: routeNames.supplierCommitmentsView },
            },
            {
                path: 'commitments',
                name: routeNames.supplierCommitmentsView,
                beforeEnter: defaultBeforeEnter,
                children: [
                    {
                        path: ':supplierCommitmentId',
                        name: routeNames.supplierCommitmentView,
                        component: EmptyRouteComponent,
                        beforeEnter: defaultBeforeEnter,
                    },
                ],
            },
            {
                path: 'variable-funding',
                name: routeNames.variableFundingView,
                component: EmptyRouteComponent,
                beforeEnter: defaultBeforeEnter,
            },
        ],
    },
];

export default routes;
